"use client";
import { IBlocks, ITheme } from "@/types";
import React from "react";
import type { BlockUpdateFunction } from "./utils/blocks-map";
import AdminPopover from "./utils/AdminPopover";
import { cn } from "@/lib/utils";

interface Props {
    edit?: boolean;
    block: IBlocks;
    update?: BlockUpdateFunction;
}
function extractVideoId(url: string): string | null {
    const regex =
        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);

    return match ? match[1] : null;
}
export default function BlockYoutubeVideo({ edit, block, update }: Props) {
    const [blockUpdate, setBlockUpdate] = React.useState(block);
    return (
        <AdminPopover
            edit={edit}
            className={block.show ? "" : "opacity-30"}
            title={`YouTube Video - ${blockUpdate.url}`}
            block={block}
            update={update}
            setBlockUpdate={setBlockUpdate}
        >
            <div
                className={cn(
                    "flex w-full flex-col text-user-heading-text-color",
                    "block-" + block.id
                )}
            >
                {!blockUpdate.options?.hide_title && (
                    <h4>{blockUpdate.name}</h4>
                )}
                <iframe
                    id="youtube-video"
                    className="aspect-video h-full w-full rounded-lg"
                    src={`https://www.youtube.com/embed/${extractVideoId(blockUpdate.url)}?enablejsapi=1&autoplay=false&mute=true`}
                    allow=""
                    allowFullScreen
                />
            </div>
        </AdminPopover>
    );
}
